import { render } from "./ProfileTopper.vue?vue&type=template&id=45065a10"
import script from "./ProfileTopper.vue?vue&type=script&lang=js"
export * from "./ProfileTopper.vue?vue&type=script&lang=js"

import "./ProfileTopper.vue?vue&type=style&index=0&id=45065a10&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__